import * as React from 'react';
export const checkSvg = React.forwardRef(function checkSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.701 1.203a.85.85 0 0 1 .096 1.198l-6.65 7.8a.85.85 0 0 1-1.26.038l-3.65-3.8A.85.85 0 0 1 1.463 5.26l3 3.123 6.04-7.085a.85.85 0 0 1 1.198-.096Z',
    }),
  );
});
checkSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var check = {
  category: 'icon',
  colorable: true,
  name: 'check',
  svg: checkSvg,
};
